import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import "@/lib/i18n";

import { AuthProvider, useAuth } from "@/lib/auth";
import Layout from "@/components/Layout";

import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import Dashboard from "@/pages/Dashboard";
import RiskMap from "@/pages/RiskMap";
import Controls from "@/pages/Controls";
import Documents from "@/pages/Documents";
import CalendarPage from "@/pages/Calendar";
import Reports from "@/pages/Reports";
import AdeCommunications from "@/pages/AdeCommunications";
import Certification from "@/pages/Certification";
import AISettings from "@/pages/AISettings";
import PmiGuide from "@/pages/PmiGuide";
import SettingsPage from "@/pages/Settings";
import AdminPanel from "@/pages/AdminPanel";

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center text-slate-500" data-testid="loading-screen">Caricamento…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/onboarding" element={<Protected><Onboarding /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/risks" element={<RiskMap />} />
            <Route path="/controls" element={<Controls />} />
            <Route path="/documents" element={<Documents />} />
            <Route path="/calendar" element={<CalendarPage />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/ade" element={<AdeCommunications />} />
            <Route path="/certification" element={<Certification />} />
            <Route path="/ai-settings" element={<AISettings />} />
            <Route path="/pmi" element={<PmiGuide />} />
            <Route path="/settings" element={<SettingsPage />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
